import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NotificationWindow from '../notifications/notificationsBar';
import { useAuth } from "../dataContext/AuthContext";
import { User, Menu } from 'lucide-react';
import ProfileDropdown from '../profile/profile_window';
import TargetedNotificationWindow from '../notifications/targetedNotificationBar';
import { useClickOutside } from '../hooks/useClickOutside';
import { getPageTitle } from '../layout/navConfig';

function Topbar({ onMenuToggle }) {
  const { userId, organizationId } = useAuth();
  const location = useLocation();
  const profileRef = useRef(null);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const pageTitle = getPageTitle(location.pathname);

  useClickOutside(profileRef, () => setIsProfileOpen(false), isProfileOpen);

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between gap-2 px-3 sm:px-4 md:px-6 w-full sticky top-0 z-40">
      {/* Left: hamburger (mobile) + current page */}
      <div className="flex items-center min-w-0">
        <button
          type="button"
          onClick={onMenuToggle}
          className="p-2 -ml-1 mr-1 rounded-md hover:bg-gray-100 md:hidden"
          aria-label="Open menu"
        >
          <Menu className="h-6 w-6 text-gray-600" />
        </button>
        {pageTitle && (
          // Mobile only: pages render their own heading on larger screens
          <span className="md:hidden text-base font-semibold text-gray-800 truncate">{pageTitle}</span>
        )}
      </div>

      {/* Right: notifications + profile */}
      <div className="flex items-center gap-1 sm:gap-2 md:gap-3 flex-shrink-0">
        <NotificationWindow userId={userId} />
        <TargetedNotificationWindow userId={userId} organizationId={organizationId}/>
        <div className="relative ml-1 sm:ml-2" ref={profileRef}>
          <button
            type="button"
            className="p-1.5 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"
            onClick={() => setIsProfileOpen((open) => !open)}
            aria-label="Account menu"
            aria-haspopup="menu"
            aria-expanded={isProfileOpen}
          >
            <User className="h-6 w-6 text-gray-600" />
          </button>
          <ProfileDropdown
            isOpen={isProfileOpen}
            onClose={() => setIsProfileOpen(false)}
          />
        </div>
      </div>
    </header>
  );
}

export default Topbar;
